/**
 * 统一公共组件，批量注册
 *
 */

import barchart from "./echarts/barChart/index";
import linechart from "./echarts/lineChart/index";
import lineandbarchart from "./echarts/lineAndBar/index";
import lineBarChart from "./echarts/lineBarChart/index";
import bar from "./echarts/bar/index";
import bieChart from "./echarts/bieChart/index.vue";
import subsectionVhart from "./echarts/barSubsection/index.vue";
import pieChart from "./echarts/pieChart/index.vue";

export default {
  barchart,
  linechart,
  lineandbarchart,
  lineBarChart,
  bar,
  bieChart,
  subsectionVhart,
  pieChart,
};
